var styleDataHash = "3c3cdd87";
const injectCss = (() => {
  var css = `.j0QHq{--shimmer-base-color:#f5f5f5;background-color:var(--shimmer-base-color);pointer-events:none;z-index:1}.C6yUz,.j0QHq{inset:0;position:absolute}.C6yUz{overflow:hidden}.C6yUz:after{animation:Ja9Oh 1s linear infinite;background:linear-gradient(90deg,transparent,hsla(0,0%,100%,.3),transparent 50%);bottom:0;content:"";left:0;position:absolute;right:0;top:0;transform:translateX(-100%)}@keyframes Ja9Oh{to{transform:translateX(100%)}}`;
  var isTest = typeof process !== "undefined" && process.env && false;
  if (isTest || !css || typeof document === "undefined") {
    return;
  }
  if (document.querySelector('style[data-ricos-style-hash="' + styleDataHash + '"]')) {
    return;
  }
  var head = document.head || document.getElementsByTagName("head")[0];
  var style = document.createElement("style");
  style.setAttribute("data-ricos-style-hash", styleDataHash);
  style.type = "text/css";
  head.appendChild(style);
  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
});
injectCss();
var layout_background_loader_default = {
  "overlay": "j0QHq",
  "shimmer": "C6yUz",
  "layout-shimmer": "Ja9Oh"
};
export {
  layout_background_loader_default as default,
  injectCss
};
//# sourceMappingURL=layout-background-loader-scss.js.map
